module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/eliminar-pill-va.6c1b3397.svg";